module.exports = "/_next/static/images/Sam-e57d02951f9bc6f09300c4ce31f5c48f.jpg";